import React from 'react';
import { Button, ButtonGroup } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { getProgramColorByType } from '../../../../../../helpers/travel/travelCalcHelpers';
import { black, efesBackgroundLight, white } from '../../../../../../theme';

import useStyles from '../../makeStyles';

const Tabs = ({ plans, selectedPlan, handleChangePlan, type }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <ButtonGroup color="primary" className={classes.buttonGroup}>
      {plans.map((plan) => (
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
        <Button
          key={plan.id}
          disableTouchRipple
          disableRipple
          variant={selectedPlan === plan.label ? 'contained' : 'text'}
          style={{
            backgroundColor:
              selectedPlan === plan.label ? getProgramColorByType(plan.label) : 'transparent',
            color: selectedPlan === plan.label ? white : black,
          }}
          className={classes.programButton}
          onClick={() => selectedPlan !== plan.label && handleChangePlan(plan.label)}
          onMouseOver={(e) => {
            if (selectedPlan !== plan.label) {
              e.currentTarget.style.backgroundColor = efesBackgroundLight;
            }
          }}
          onMouseLeave={(e) => {
            if (selectedPlan !== plan.label) {
              e.currentTarget.style.backgroundColor = 'transparent';
            }
          }}
        >
          {t(`${type}.types.${plan.label}.title`)}
        </Button>
      ))}
    </ButtonGroup>
  );
};

Tabs.propTypes = {
  handleChangePlan: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  plans: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedPlan: PropTypes.string.isRequired,
};

export default Tabs;
